export const MaximumImageBytes = 100 * 1024;

export async function PrepareImageFile(file: File): Promise<File> {
  if (!file.type.startsWith("image/"))
    throw new Error("Select a valid image file.");
  if (file.size <= MaximumImageBytes) return file;

  const bitmap = await createImageBitmap(file);
  let width = bitmap.width;
  let height = bitmap.height;
  let quality = 0.9;

  for (let attempt = 0; attempt < 10; attempt += 1) {
    const scale = attempt < 4 ? 1 : 0.85;
    width = Math.max(320, Math.round(width * scale));
    height = Math.max(320, Math.round(height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d")?.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/webp", quality),
    );
    if (blob && blob.size <= MaximumImageBytes) {
      bitmap.close();
      return new File([blob], `${file.name.replace(/\.[^.]+$/, "")}.webp`, {
        type: "image/webp",
        lastModified: Date.now(),
      });
    }
    quality = Math.max(0.55, quality - 0.08);
  }

  bitmap.close();
  throw new Error(
    "The image could not be reduced below 100 KB. Choose a smaller image.",
  );
}
